const collapsedClass = 'collapsed';
const expandedClass = 'expanded';
const toggledClass = 'toggled';
const toggleSelector = '.dropdown-toggle';
const targetSelector = '.dropdown';
const hoverClass = 'hover';
const anchorSelector = '.dropdown a';
const dontDismssSelector = '.dont-dismiss';


const MOUSEOUT = new MouseEvent('mouseout', {
  'view': window,
  'bubbles': true,
  'cancelable': true
});


function initDropdowns(){
    document.querySelectorAll(toggleSelector).forEach( dropdown => {

        const toggleTarget = dropdown.querySelector(targetSelector);

        let dismisshandler = 0;

        function dismiss(e){
            if (e.target.closest(dontDismssSelector)){
                return;
            }
            if ((e.target.closest(anchorSelector) && e.target.closest(targetSelector) === toggleTarget) || e.target.closest(toggleSelector) !== dropdown) {
                toggleTarget.classList.remove(expandedClass);
                toggleTarget.classList.add(collapsedClass);
                dropdown.classList.remove(hoverClass);
                dropdown.dispatchEvent(MOUSEOUT);
                dropdown.classList.remove(toggledClass);
                document.removeEventListener('click', dismiss);
                dismisshandler = 0;
                console.log('removed event listener');
            }
        }

        dropdown.addEventListener('mouseover', ()=>{
           dropdown.classList.add(hoverClass);
        });

        dropdown.addEventListener('mouseout', ()=>{
            dropdown.classList.remove(hoverClass);
        });

        dropdown.addEventListener('click', ()=>{
            toggleTarget.classList.toggle(collapsedClass);
            toggleTarget.classList.toggle(expandedClass);
            dropdown.classList.toggle(toggledClass);
            dropdown.classList.toggle(hoverClass);
            dismisshandler++;
            if (dismisshandler === 1){
                document.addEventListener('click', dismiss);
            }
        });
    });
}

export default initDropdowns;